/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  HomepageSetting,
  HomepageSettingInput,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Homepage settings
 */
export const homepageSettings = (

 signal?: AbortSignal
) => {


      return axiosClient<HomepageSetting>(
      {url: `/homepage-settings`, method: 'GET', signal
    },
      );
    }




export const getHomepageSettingsQueryKey = () => {
    return [
    'homepage-settings'
    ] as const;
    }


export const getHomepageSettingsQueryOptions = <TData = Awaited<ReturnType<typeof homepageSettings>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof homepageSettings>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHomepageSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof homepageSettings>>> = ({ signal }) => homepageSettings(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof homepageSettings>>, TError, TData>
}

export type HomepageSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof homepageSettings>>>
export type HomepageSettingsQueryError = ErrorType<StandardError>


/**
 * @summary Homepage settings
 */

export function useHomepageSettings<TData = Awaited<ReturnType<typeof homepageSettings>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof homepageSettings>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHomepageSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update the homepage settings
 */
export const updateHomepageSettings = (
    homepageSettingInput: MaybeRefOrGetter<HomepageSettingInput>,
 signal?: AbortSignal
) => {
      homepageSettingInput = toValue(homepageSettingInput);

      return axiosClient<HomepageSetting>(
      {url: `/homepage-settings`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: homepageSettingInput, signal
    },
      );
    }




export const getUpdateHomepageSettingsMutationKey = () => ['updateHomepageSettings'] as const;

export const getUpdateHomepageSettingsMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHomepageSettings>>, TError,UpdateHomepageSettingsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateHomepageSettings>>, TError,UpdateHomepageSettingsMutationVariables, TContext> => {

const mutationKey = getUpdateHomepageSettingsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHomepageSettings>>, UpdateHomepageSettingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateHomepageSettings(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateHomepageSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateHomepageSettings>>>
    export type UpdateHomepageSettingsMutationBody = HomepageSettingInput
    export type UpdateHomepageSettingsMutationError = ErrorType<ValidationError | StandardError>
    export type UpdateHomepageSettingsMutationVariables = {data: HomepageSettingInput}

    /**
 * @summary Update the homepage settings
 */
export const useUpdateHomepageSettings = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHomepageSettings>>, TError,UpdateHomepageSettingsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateHomepageSettings>>,
        TError,
        UpdateHomepageSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateHomepageSettingsMutationOptions(options), queryClient);
    }
